var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.903 65.7756C123.903 101.644 74.8679 144.667 74.8679 144.667C74.8679 144.667 25.833 101.644 25.833 65.7756C25.9299 37.9551 47.8309 15.5 74.9648 15.5C102.099 15.5 124 37.9551 124 65.7756H123.903Z",
    stroke: "#2B318A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.917 87.8333C87.7576 87.8333 98.167 77.4239 98.167 64.5833C98.167 51.7427 87.7576 41.3333 74.917 41.3333C62.0764 41.3333 51.667 51.7427 51.667 64.5833C51.667 77.4239 62.0764 87.8333 74.917 87.8333Z",
    fill: "#2B318A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionPurple);
export default __webpack_public_path__ + "static/media/positionPurple.ca9e53a614cced4da10217029f30fa90.svg";
export { ForwardRef as ReactComponent };